import * as Team from './team.ts';
import * as UserTasks from './user_tasks.ts';
import * as Attachments from './attachments.ts';
import * as TaskChecklists from './task_checklists.ts';
import * as ChecklistTasks from './checklist_tasks.ts';
import * as Contacts from './contacts.ts';
import * as CustomFields from './custom_fields.ts';
import * as Quickstart from './quickstart.ts';
import * as TaskChecklistClones from './task_checklist_clones.ts';
import * as TaskChecklistAssignment from './task_checklist_assignment.ts';
import * as OneOffTaskAssignments from './one_off_task_assignments.ts';
import * as TeamWorkflowTemplates from './team_workflow_templates.ts';
import * as EsignatureSubmissions from './esignature_submissions.ts';
import * as Workflows from './workflows.ts';
import * as WorkflowTemplates from './workflow_templates.ts';
import * as WorkflowCondition from './workflow_condition.ts';
import * as WorkflowActions from './workflow_actions.ts';
import * as WorkflowDefinitions from './workflow_definitions.ts';
import * as EmailTemplates from './email_templates.ts';
import * as SmsTemplates from './sms_templates.ts';
import * as Users from './users.ts';
import * as InAppPhoneCalls from './in_app_phone_calls.ts';
import * as ContactNotes from './contact_notes.ts';
import * as ContactEmails from './contact_emails.ts';
import * as ContactEvents from './contact_event.ts';
import * as ContactMessages from './contact_messages.ts';
import * as CustomFieldValue from './custom_field_values.ts';
import * as AgentPipelineReview from './agent/pipeline_review.ts';
import * as AgentCurrent from './agent/current.ts';
import * as AgentReferrals from './agent/referrals.ts';
import * as AgentUniversityCourse from './agent/university/course.ts';
import * as AgentUniversityLectureCompletion from './agent/university/lecture_completion.ts';
import * as PipelineReviews from './pipeline_reviews.ts';
import * as PipelineReviewConfig from './pipeline_review/configurations.ts';
import * as PipelineReviewQuestions from './pipeline_review/questions.ts';
import * as PipelineReviewAnswers from './pipeline_review/answers.ts';
import * as PipelineReviewContactConfigurations from './pipeline_review/contact_configurations.ts';
import * as PipelineReviewContactConfigurationBatches from './pipeline_review/contact_configuration_batches.ts';
import * as Dashboard from './dashboard.ts';
import * as ContactInterview from './public/contact_interview.ts';
import * as ScheduledActions from './scheduled_actions.ts';
import * as CalendarConnections from './calendar_connections.ts';
import * as WorkflowScheduledActionInstances from './workflow_scheduled_action_instances.ts';
import * as MonthlyMarketingBudgets from './monthly_marketing_budgets.ts';
import * as MonthlyMarketingBudgetUpdateRequests from './monthly_marketing_budget_update_requests.ts';
import * as PipelineReviewAiDigests from './pipeline_review_ai_digests.ts';

export const Api = {
  Team,
  UserTasks,
  Attachments,
  TaskChecklists,
  TaskChecklistAssignment,
  TaskChecklistClones,
  ChecklistTasks,
  Contacts,
  ContactNotes,
  ContactEmails,
  ContactEvents,
  ContactMessages,
  Dashboard,
  CustomFields,
  CustomFieldValue,
  Quickstart,
  OneOffTaskAssignments,
  TeamWorkflowTemplates,
  EsignatureSubmissions,
  Workflows,
  WorkflowTemplates,
  WorkflowCondition,
  WorkflowActions,
  WorkflowDefinitions,
  EmailTemplates,
  SmsTemplates,
  Users,
  InAppPhoneCalls,
  CalendarConnections,
  WorkflowScheduledActionInstances,
  PipelineReviews,
  PipelineReviewAiDigests,
  PipelineReviewConfig,
  PipelineReviewQuestions,
  PipelineReviewAnswers,
  PipelineReviewContactConfigurations,
  PipelineReviewContactConfigurationBatches,
  AgentPipelineReview,
  AgentCurrent,
  AgentReferrals,
  AgentUniversityCourse,
  AgentUniversityLectureCompletion,
  Public: {
    ContactInterview,
  },
  ScheduledActions,
  MonthlyMarketingBudgets,
  MonthlyMarketingBudgetUpdateRequests,
};

export const ApiPlugin = {
  install(app: {
    config: {
      globalProperties: {
        $api: {
          Team: typeof Team;
          UserTasks: typeof UserTasks;
          Attachments: typeof Attachments;
          TaskChecklists: typeof TaskChecklists;
          TaskChecklistAssignment: typeof TaskChecklistAssignment;
          TaskChecklistClones: typeof TaskChecklistClones;
          ChecklistTasks: typeof ChecklistTasks;
          Contacts: typeof Contacts;
          ContactNotes: typeof ContactNotes;
          ContactEmails: typeof ContactEmails;
          ContactEvents: typeof ContactEvents;
          ContactMessages: typeof ContactMessages;
          Dashboard: typeof Dashboard;
          CustomFields: typeof CustomFields;
          CustomFieldValue: typeof CustomFieldValue;
          Quickstart: typeof Quickstart;
          OneOffTaskAssignments: typeof OneOffTaskAssignments;
          TeamWorkflowTemplates: typeof TeamWorkflowTemplates;
          EsignatureSubmissions: typeof EsignatureSubmissions;
          Workflows: typeof Workflows;
          WorkflowTemplates: typeof WorkflowTemplates;
          WorkflowCondition: typeof WorkflowCondition;
          WorkflowActions: typeof WorkflowActions;
          WorkflowDefinitions: typeof WorkflowDefinitions;
          EmailTemplates: typeof EmailTemplates;
          SmsTemplates: typeof SmsTemplates;
          Users: typeof Users;
          InAppPhoneCalls: typeof InAppPhoneCalls;
          CalendarConnections: typeof CalendarConnections;
          WorkflowScheduledActionInstances: typeof WorkflowScheduledActionInstances;
          PipelineReviews: typeof PipelineReviews;
          PipelineReviewAiDigests: typeof PipelineReviewAiDigests;
          PipelineReviewConfig: typeof PipelineReviewConfig;
          PipelineReviewQuestions: typeof PipelineReviewQuestions;
          PipelineReviewAnswers: typeof PipelineReviewAnswers;
          PipelineReviewContactConfigurations: typeof PipelineReviewContactConfigurations;
          PipelineReviewContactConfigurationBatches: typeof PipelineReviewContactConfigurationBatches;
          AgentPipelineReview: typeof AgentPipelineReview;
          AgentCurrent: typeof AgentCurrent;
          AgentReferrals: typeof AgentReferrals;
          AgentUniversityCourse: typeof AgentUniversityCourse;
          AgentUniversityLectureCompletion: typeof AgentUniversityLectureCompletion;
          Public: {
            ContactInterview: typeof ContactInterview;
          };
          ScheduledActions: typeof ScheduledActions;
          MonthlyMarketingBudgets: typeof MonthlyMarketingBudgets;
          MonthlyMarketingBudgetUpdateRequests: typeof MonthlyMarketingBudgetUpdateRequests;
        };
      };
    };
  }) {
    app.config.globalProperties.$api = Api;
  },
};
